module.exports = __webpack_public_path__ + "static/ustunperformans-fc1c6ef408d7d36157b4f40eb66ceb24.webp";